import { c as _c } from "react/compiler-runtime";
interface InternalMedicineIconProps {
  className?: string;
  size?: number;
}
const InternalMedicineIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M6.13226 24C5.12216 22.5859 4.1929 19.2727 6.13229 17.3333C8.55652 14.9091 10.9809 19.7576 14.0111 14.9091C13.6071 13.899 12.9202 11.5152 13.4051 10.0606C12.395 9.65657 10.496 8.24242 10.9809 5.81818M13.4051 4C13.2031 4.80808 13.2839 6.54545 15.2233 7.0303C17.0414 6.0202 21.1626 5.21212 23.102 10.0606C25.5263 16.1212 20.0717 21.5758 17.6475 22.1818C15.2233 22.7879 12.1931 22.7879 9.16267 20.3636C8.75864 20.1616 7.95056 20 7.95056 20.9697C7.95056 21.9394 8.5565 22.9899 9.16256 23.3939" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== t3 || $[4] !== t5) {
    t7 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}</svg>;
    $[3] = t3;
    $[4] = t5;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
};
export default InternalMedicineIcon;